<mat-card *ngIf="IS_NOT_NULL_OR_UNDEFINED(projectCopy)" class="padding-0-5 primary-text specifications-v2-card" [ngClass]="{'collapsed': isHeaderCollapsed}">
	<mat-card-content>
		<!-- ========== PROCUREMENT LAYOUT V2 ========== -->
		<ng-container *ngIf="projectCopy.type === PROJECT_TYPES.PROCUREMENT.value">

			<!-- Collapsed Summary Bar -->
			<div
				*ngIf="isHeaderCollapsed"
				(click)="toggleHeaderCollapse()"
				class="collapsed-summary-bar cursor-pointer"
				fxLayout="row"
				fxLayoutAlign="space-between center"
			>
				<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2rem" fxFlex>
					<!-- Lane -->
					<div class="summary-item" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
						<span class="summary-value fw-700">{{ getSummaryLaneText() }} {{ getEquipmentAbbreviation() }}</span>
					</div>

					<!-- Divider -->
					<span class="summary-divider">|</span>

					<!-- Customer -->
					<div class="summary-item" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
						<span class="summary-label">Customer:</span>
						<span class="summary-value">{{ projectCopy.customerDTO?.name || projectCopy.revenueCode || 'Not set' }}</span>
					</div>

					<!-- Divider -->
					<span class="summary-divider">|</span>

					<!-- Max Buy -->
					<div class="summary-item" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
						<span class="summary-label">Max Buy:</span>
						<span class="summary-value fw-700" [class.text-muted]="projectCopy.maxBuy == null">
							{{ projectCopy.maxBuy != null ? ('$' + (projectCopy.maxBuy | number:'1.0-0')) : '—' }}
						</span>
					</div>

					<!-- Divider -->
					<span class="summary-divider">|</span>

					<!-- Offer Rate -->
					<div class="summary-item" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
						<span class="summary-label">Offer:</span>
						<span class="summary-value fw-700" [class.text-muted]="projectCopy.offerRate == null">
							{{ projectCopy.offerRate != null ? ('$' + (projectCopy.offerRate | number:'1.0-0')) : '—' }}
						</span>
					</div>

					<!-- Divider -->
					<span class="summary-divider">|</span>

					<!-- Assigned User -->
					<div class="summary-item" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
						<span class="summary-label">Assigned:</span>
						<span class="summary-value" [class.text-muted]="!projectCopy.assigneeId">{{ getAssignedUserName() }}</span>
					</div>
				</div>

				<!-- Expand caret -->
				<mat-icon class="expand-icon">keyboard_arrow_down</mat-icon>
			</div>

			<!-- Expanded Form -->
			<ng-container *ngIf="!isHeaderCollapsed">
				<!-- Collapse header row -->
				<div
					(click)="toggleHeaderCollapse()"
					class="collapse-header-row cursor-pointer"
					fxLayout="row"
					fxLayoutAlign="space-between center"
				>
					<span class="collapse-header-text">Project Details</span>
					<mat-icon class="collapse-icon">keyboard_arrow_up</mat-icon>
				</div>

				<!-- Row 1: Project Name | Customer | Lane | Assigned User -->
				<div class="font-size-14 p-0-3" fxLayout="row" fxLayoutGap="1.5rem">
					<div fxFlex="25" fxLayoutAlign="start center">
						<mat-form-field class="custom-form-field" fxFlex="100">
							<input
								[(ngModel)]="projectCopy.name"
								autocomplete="off"
								floatLabel="never"
								fxFlex
								matInput
							/>
						</mat-form-field>
					</div>
					<div
						*ngIf="
							IS_NOT_NULL_OR_UNDEFINED(usersList) &&
							(IS_NOT_NULL_OR_UNDEFINED(projectCopy.customerDTO) || IS_EMPTY(projectCopy.revenueCode))
						"
						fxFlex="25"
						fxLayoutAlign="start center"
					>
						<app-customer-popover
							*ngIf="accountSettings.ROLE_BASED_CUSTOMER_DATA_ACCESS"
							(setCustomer)="setCustomer($event)"
							[customerSelected]="projectCopy.customerDTO"
							fxFlex
						></app-customer-popover>
					</div>
					<div
						*ngIf="
							IS_NOT_EMPTY(projectCopy.revenueCode) && IS_NULL_OR_UNDEFINED(projectCopy.customerDTO)
						"
						fxFlex="25"
						fxLayoutAlign="start center"
					>
						<div class="fw-700" fxFlex fxLayoutAlign="start center">Revenue Code:</div>
						<div fxFlex fxLayoutAlign="end center">
							<mat-form-field class="custom-form-field" fxFlexFill>
								<input [(ngModel)]="projectCopy.revenueCode" autocomplete="off" fxFlex matInput />
							</mat-form-field>
						</div>
					</div>
					<div fxFlex="25" fxLayout="row">
						<div class="fw-700 primary-text lane-label" fxFlex="none" fxLayoutAlign="start center">Lane:</div>
						<div
							(click)="openLaneEditDialog()"
							class="cursor-pointer lane-field"
							fxLayout="row"
							fxLayoutAlign="space-between center"
							fxFlex
						>
							<ng-container *ngIf="projectCopy.originCity || projectCopy.originState || projectCopy.destCity || projectCopy.destState; else noLane">
								<span class="primary-text text-ellipsis">
									{{ projectCopy.originCity && projectCopy.originState ? projectCopy.originCity + ', ' + (projectCopy.originState | stateDisplay) : (projectCopy.originCity || (projectCopy.originState | stateDisplay) || '') }}
									-&gt;
									{{ projectCopy.destCity && projectCopy.destState ? projectCopy.destCity + ', ' + (projectCopy.destState | stateDisplay) : (projectCopy.destCity || (projectCopy.destState | stateDisplay) || '') }}
									({{ projectEquipments.length > 0 ? projectEquipments.join(', ') : 'No Equipment' }})
								</span>
							</ng-container>
							<ng-template #noLane>
								<span class="lane-placeholder">No Lane</span>
							</ng-template>
							<mat-icon class="vertical-align-middle primary-text">keyboard_arrow_down</mat-icon>
						</div>
					</div>
					<div fxFlex="25">
						<div fxFlex>
							<app-user-popover
								(userChanged)="assigneeUpdated($event)"
								[isEnabled]="userPopoverComponent.enabled"
								[placeholder]="userPopoverComponent.placeholder"
								[selectedUsers]="userPopoverComponent.selectedUsers"
								[singleselect]="true"
								[usersList]="usersList"
								fxFlex
							>
							</app-user-popover>
						</div>
					</div>
				</div>
				<!-- Row 2: Commodity | Weight | Load Volume | Load Count -->
				<div class="font-size-14 p-0-3" fxLayout="row" fxLayoutGap="1.5rem">
					<div fxFlex="25" fxLayoutAlign="start center">
						<div class="fw-700" fxFlex fxLayoutAlign="start center">Commodity:</div>
						<div fxFlex fxLayoutAlign="end center">
							<mat-form-field class="custom-form-field" fxFlexFill>
								<input
									[(ngModel)]="projectCopy.commodity"
									autocomplete="off"
									floatLabel="never"
									fxFlex
									matInput
								/>
							</mat-form-field>
						</div>
					</div>
					<div fxFlex="25">
						<div class="fw-700" fxFlex fxLayoutAlign="start center">Weight:</div>
						<div fxFlex fxLayoutAlign="end center">
							<mat-form-field class="custom-form-field" fxFlexFill>
								<input
									[(ngModel)]="projectCopy.weight"
									autocomplete="off"
									floatLabel="never"
									fxFlex
									matInput
								/>
								<span matSuffix>lbs</span>
							</mat-form-field>
						</div>
					</div>
					<div fxFlex="25">
						<div class="fw-700" fxFlex fxLayoutAlign="start center">Load Volume:</div>
						<div fxFlex fxLayoutAlign="start center">
							<mat-form-field class="custom-form-field" floatLabel="never" fxFlex>
								<mat-select [(ngModel)]="projectCopy.loadVolumeDuration" disableOptionCentering>
									<mat-option>Select</mat-option>
									<mat-option *ngFor="let duration of loadVolumeDuration" [value]="duration">
										{{ duration }}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
					</div>
					<div fxFlex="25" fxLayoutAlign="start center">
						<div class="fw-700" fxFlex fxLayoutAlign="start center">Load Count:</div>
						<div fxFlex fxLayoutAlign="end center">
							<mat-form-field class="custom-form-field" fxFlexFill>
								<input [(ngModel)]="projectCopy.loadVolume" autocomplete="off" fxFlex matInput />
							</mat-form-field>
						</div>
					</div>
				</div>
				<!-- Row 3: Max Buy | Offer Rate | Best Rate | Stage -->
				<div class="font-size-14 p-0-3" fxLayout="row" fxLayoutGap="1.5rem">
					<div fxFlex="25" fxLayoutAlign="start center">
						<div class="fw-700" fxFlex fxLayoutAlign="start center">Max Buy:</div>
						<div fxFlex fxLayoutAlign="end center">
							<mat-form-field class="custom-form-field" fxFlexFill>
								<mat-icon class="primary-light-color vertical-align-bottom" matPrefix
									>attach_money
								</mat-icon>
								<input
									[(ngModel)]="projectCopy.maxBuy"
									autocomplete="off"
									floatLabel="never"
									fxFlex
									mask="separator"
									thousandSeparator=","
									matInput
								/>
							</mat-form-field>
						</div>
					</div>
					<div fxFlex="25" fxLayoutAlign="start center">
						<div class="fw-700" fxFlex fxLayoutAlign="start center">Offer Rate:</div>
						<div fxFlex fxLayoutAlign="end center">
							<mat-form-field class="custom-form-field" fxFlexFill>
								<mat-icon class="primary-light-color vertical-align-bottom" matPrefix
									>attach_money
								</mat-icon>
								<input
									[(ngModel)]="projectCopy.offerRate"
									(ngModelChange)="projectCopy.offerRate = $event === '' ? null : $event"
									autocomplete="off"
									floatLabel="never"
									fxFlex
									mask="separator"
									thousandSeparator=","
									matInput
								/>
							</mat-form-field>
						</div>
					</div>
					<div (click)="submitLastBid()" class="cursor-pointer" fxFlex="25">
						<div class="fw-700" fxFlex fxLayoutAlign="start center">Best Rate:</div>
						<div class="font-size-14 underline" fxFlex fxLayoutAlign="end center">
							<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(projectCopy.bestRate)">
								{{ projectCopy.bestRate / 100 | currency: 'USD' : 'symbol' : '1.0-2' }}
							</span>
							<span
								*ngIf="IS_NULL_OR_UNDEFINED(projectCopy.bestRate)"
								class="font-size-14"
								fxLayoutAlign="center center"
							>
								<mat-icon
									[inline]="true"
									[matTooltip]="TOOLTIP_MSG.BEST_RATE"
									class="primary-text w-inherit"
									matSuffix
									matTooltipClass="custom-tooltip"
								>
									info
								</mat-icon>
							</span>
						</div>
					</div>
					<div fxFlex="25">
						<div class="fw-700" fxFlex fxLayoutAlign="start center">Stage:</div>
						<div fxFlex fxLayoutAlign="start center">
							<mat-form-field class="custom-form-field" floatLabel="never" fxFlex="100">
								<mat-select [(ngModel)]="projectCopy.stageId" disableOptionCentering>
									<mat-option *ngFor="let stage of PROJECT_STAGES" [value]="stage.type">
										{{ stage.label }}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
					</div>
				</div>
				<!-- Automated Carrier Negotiation (CN-8626) — per-workflow override of the account default.
					 Gated on the account entitlement: only accounts CargoChief has entitled can see/configure it. -->
				<div
					*ngIf="baConfigService.AUTO_ACCEPT_ENTITLED"
					class="font-size-14 p-0-3 m-t-1"
					fxLayout="column"
					fxLayoutGap="0.5rem"
				>
					<div fxLayout="row" fxLayoutAlign="start center">
						<mat-checkbox
							[(ngModel)]="autoAcceptOverride"
							(change)="onAutoAcceptOverrideChange($event.checked)"
							[labelPosition]="'after'"
							color="primary"
						>
							Override account negotiation for this workflow
						</mat-checkbox>
						<mat-icon class="primary-light-color ml-1" matTooltip="When off, this workflow inherits the account-level Automated Carrier Negotiation settings. When on, the values below apply only to this workflow." matTooltipClass="custom-tooltip">
							info
						</mat-icon>
					</div>
					<div
						*ngIf="autoAcceptOverride"
						fxLayout="row"
						fxLayoutGap="2rem"
						fxLayoutAlign="start end"
						class="m-l-2 auto-accept-settings-row"
					>
						<mat-checkbox
							[(ngModel)]="projectCopy.autoAcceptEnabled"
							[labelPosition]="'before'"
							color="primary"
						>
							Enable automated negotiation
						</mat-checkbox>
						<div fxLayout="row" fxLayoutAlign="start end" fxLayoutGap="0.5rem">
							<span class="m-r-1">Margin below ceiling</span>
							<mat-icon class="primary-light-color m-r-1" matTooltip="How far below the load ceiling an offer must land to auto-accept — percentage of the ceiling or a fixed dollar amount. Must be greater than 0." matTooltipClass="custom-tooltip">
								info
							</mat-icon>
							<mat-radio-group
								[(ngModel)]="projectCopy.autoAcceptMarginType"
								(change)="onAutoAcceptMarginTypeChange($event.value)"
							>
								<mat-radio-button class="font-size-12" color="primary" value="Percentage"
									>Percentage</mat-radio-button
								>
								&nbsp;&nbsp;
								<mat-radio-button class="font-size-12" color="primary" value="Dollar"
									>Fixed</mat-radio-button
								>
							</mat-radio-group>
							<mat-form-field class="auto-accept-value-input auto-accept-field" subscriptSizing="dynamic">
								<span matPrefix class="m-r-1">{{ autoAcceptMarginPlaceholder }}</span>
								<input [(ngModel)]="autoAcceptMarginDisplay" matInput type="number" min="1" />
							</mat-form-field>
						</div>
						<div fxLayout="row" fxLayoutAlign="start end" fxLayoutGap="0.5rem">
							<span class="m-r-1">Urgency window (hours)</span>
							<mat-form-field class="auto-accept-value-input auto-accept-field" subscriptSizing="dynamic">
								<input [(ngModel)]="projectCopy.autoAcceptTimeXHours" matInput type="number" />
							</mat-form-field>
						</div>
						<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
							<mat-checkbox
								[(ngModel)]="projectCopy.autoAcceptBookEnabled"
								[labelPosition]="'before'"
								color="primary"
							>
								Auto-accept &amp; book
							</mat-checkbox>
							<mat-icon class="primary-light-color" matTooltip="When on, an acceptable negotiated offer is auto-accepted and the load booked (a form of Book Now). When off, the Booking Assistant recommends you accept — it does not book." matTooltipClass="custom-tooltip">
								info
							</mat-icon>
						</div>
					</div>
				</div>
				<!-- Row 4: Edit Notes | Appointment Required | Project Type | UPDATE -->
				<div class="font-size-14 p-0-3" fxLayout="row" fxLayoutGap="1.5rem" fxLayoutAlign="start center">
					<div fxFlex="25" fxLayoutAlign="start center">
						<div
							(click)="showNotes = !showNotes"
							class="cursor-pointer edit-notes-field"
							fxLayout="row"
							fxLayoutAlign="start center"
						>
							<span class="primary-text">Edit Notes</span>
							<span class="ml-1 lane-placeholder text-ellipsis">({{ getFirstNoteSummary() }})</span>
							<mat-icon *ngIf="!showNotes" class="vertical-align-middle primary-text">keyboard_arrow_down</mat-icon>
							<mat-icon *ngIf="showNotes" class="vertical-align-middle primary-text">keyboard_arrow_up</mat-icon>
						</div>
					</div>
					<div fxFlex="25" fxLayoutAlign="start center">
						<mat-checkbox
							[(ngModel)]="projectCopy.appointmentRequired"
							[labelPosition]="'before'"
							color="primary"
						>
							Appointment Required
						</mat-checkbox>
						<mat-icon
							class="primary-light-color ml-1"
							matTooltip="When enabled, loads in this project will require appointment scheduling. This setting overrides the account-level Booking Assistant configuration."
							matTooltipClass="custom-tooltip"
						>
							info
						</mat-icon>
					</div>
					<!-- CN-8312: Project Type dropdown — same location/functionality as V1
					     (project-specifications.component.html:246) so users can switch
					     between Procurement and Workflow types from V2 too. -->
					<div fxFlex="25">
						<div class="fw-700" fxFlex fxLayoutAlign="start center">Project Type:</div>
						<div fxFlex fxLayoutAlign="start center">
							<mat-form-field class="custom-form-field" floatLabel="never" fxFlex>
								<mat-select [(ngModel)]="projectCopy.type" disableOptionCentering>
									<mat-option
										*ngFor="let option of procurementTypeOptions"
										[value]="option.value"
									>
										{{ option.label }}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
					</div>
					<div fxFlex="25" fxLayoutAlign="end center">
						<button
							(click)="updateProject()"
							*ngIf="!isUpdatingProject"
							[disabled]="isUpdatingProject || !isProjectUpdated()"
							color="primary"
							fxFlex="100"
							mat-raised-button
						>
							UPDATE
						</button>
						<div
							*ngIf="isUpdatingProject"
							class="h-100"
							fxLayout="row"
							fxLayoutAlign="space-around center"
						>
							<mat-spinner [diameter]="30"></mat-spinner>
						</div>
					</div>
				</div>
			</ng-container>
		</ng-container>

		<!-- ========== NON-PROCUREMENT (WORKFLOW) LAYOUT - Same as original ========== -->
		<ng-container *ngIf="projectCopy.type !== PROJECT_TYPES.PROCUREMENT.value">
			<!-- Row 1: Project Name | Customer | Lane | Assigned User -->
			<div class="font-size-14 p-0-3" fxLayout="row" fxLayoutGap="1.5rem">
				<div fxFlex="25" fxLayoutAlign="start center">
					<mat-form-field class="custom-form-field" fxFlex="100">
						<input
							[(ngModel)]="projectCopy.name"
							autocomplete="off"
							floatLabel="never"
							fxFlex
							matInput
						/>
					</mat-form-field>
				</div>
				<div
					*ngIf="
						IS_NOT_NULL_OR_UNDEFINED(usersList) &&
						(IS_NOT_NULL_OR_UNDEFINED(projectCopy.customerDTO) || IS_EMPTY(projectCopy.revenueCode))
					"
					fxFlex="25"
					fxLayoutAlign="start center"
				>
					<app-customer-popover
						*ngIf="accountSettings.ROLE_BASED_CUSTOMER_DATA_ACCESS"
						(setCustomer)="setCustomer($event)"
						[customerSelected]="projectCopy.customerDTO"
						fxFlex
					></app-customer-popover>
				</div>
				<div
					*ngIf="
						IS_NOT_EMPTY(projectCopy.revenueCode) && IS_NULL_OR_UNDEFINED(projectCopy.customerDTO)
					"
					fxFlex="25"
					fxLayoutAlign="start center"
				>
					<div class="fw-700" fxFlex fxLayoutAlign="start center">Revenue Code:</div>
					<div fxFlex fxLayoutAlign="end center">
						<mat-form-field class="custom-form-field" fxFlexFill>
							<input [(ngModel)]="projectCopy.revenueCode" autocomplete="off" fxFlex matInput />
						</mat-form-field>
					</div>
				</div>
				<div fxFlex="25" fxLayout="row">
					<div class="fw-700 primary-text lane-label" fxFlex="none" fxLayoutAlign="start center">Lane:</div>
					<div
						(click)="openLaneEditDialog()"
						class="cursor-pointer lane-field"
						fxLayout="row"
						fxLayoutAlign="space-between center"
						fxFlex
					>
						<ng-container *ngIf="projectCopy.originCity || projectCopy.originState || projectCopy.destCity || projectCopy.destState; else noLaneWorkflow">
							<span class="primary-text text-ellipsis">
								{{ projectCopy.originCity && projectCopy.originState ? projectCopy.originCity + ', ' + (projectCopy.originState | stateDisplay) : (projectCopy.originCity || (projectCopy.originState | stateDisplay) || '') }}
								-&gt;
								{{ projectCopy.destCity && projectCopy.destState ? projectCopy.destCity + ', ' + (projectCopy.destState | stateDisplay) : (projectCopy.destCity || (projectCopy.destState | stateDisplay) || '') }}
								({{ projectEquipments.length > 0 ? projectEquipments.join(', ') : 'No Equipment' }})
							</span>
						</ng-container>
						<ng-template #noLaneWorkflow>
							<span class="lane-placeholder">No Lane</span>
						</ng-template>
						<mat-icon class="vertical-align-middle primary-text">keyboard_arrow_down</mat-icon>
					</div>
				</div>
				<div fxFlex="25">
					<div fxFlex>
						<app-user-popover
							(userChanged)="assigneeUpdated($event)"
							[isEnabled]="userPopoverComponent.enabled"
							[placeholder]="userPopoverComponent.placeholder"
							[selectedUsers]="userPopoverComponent.selectedUsers"
							[singleselect]="true"
							[usersList]="usersList"
							fxFlex
						>
						</app-user-popover>
					</div>
				</div>
			</div>
			<!-- Row 2: Commodity | Weight | Load Volume | Load Count -->
			<div class="font-size-14 p-0-3" fxLayout="row" fxLayoutGap="1.5rem">
				<div fxFlex="25" fxLayoutAlign="start center">
					<div class="fw-700" fxFlex fxLayoutAlign="start center">Commodity:</div>
					<div fxFlex fxLayoutAlign="end center">
						<mat-form-field class="custom-form-field" fxFlexFill>
							<input
								[(ngModel)]="projectCopy.commodity"
								autocomplete="off"
								floatLabel="never"
								fxFlex
								matInput
							/>
						</mat-form-field>
					</div>
				</div>
				<div fxFlex="25">
					<div class="fw-700" fxFlex fxLayoutAlign="start center">Weight:</div>
					<div fxFlex fxLayoutAlign="end center">
						<mat-form-field class="custom-form-field" fxFlexFill>
							<input
								[(ngModel)]="projectCopy.weight"
								autocomplete="off"
								floatLabel="never"
								fxFlex
								matInput
							/>
							<span matSuffix>lbs</span>
						</mat-form-field>
					</div>
				</div>
				<div fxFlex="25">
					<div class="fw-700" fxFlex fxLayoutAlign="start center">Load Volume:</div>
					<div fxFlex fxLayoutAlign="start center">
						<mat-form-field class="custom-form-field" floatLabel="never" fxFlex>
							<mat-select [(ngModel)]="projectCopy.loadVolumeDuration" disableOptionCentering>
								<mat-option>Select</mat-option>
								<mat-option *ngFor="let duration of loadVolumeDuration" [value]="duration">
									{{ duration }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</div>
				<div fxFlex="25" fxLayoutAlign="start center">
					<div class="fw-700" fxFlex fxLayoutAlign="start center">Load Count:</div>
					<div fxFlex fxLayoutAlign="end center">
						<mat-form-field class="custom-form-field" fxFlexFill>
							<input [(ngModel)]="projectCopy.loadVolume" autocomplete="off" fxFlex matInput />
						</mat-form-field>
					</div>
				</div>
			</div>
			<!-- Row 3: Max Buy | Offer Rate | Best Rate | Stage -->
			<div class="font-size-14 p-0-3" fxLayout="row" fxLayoutGap="1.5rem">
				<div fxFlex="25" fxLayoutAlign="start center">
					<div class="fw-700" fxFlex fxLayoutAlign="start center">Max Buy:</div>
					<div fxFlex fxLayoutAlign="end center">
						<mat-form-field class="custom-form-field" fxFlexFill>
							<mat-icon class="primary-light-color vertical-align-bottom" matPrefix
								>attach_money
							</mat-icon>
							<input
								[(ngModel)]="projectCopy.maxBuy"
								autocomplete="off"
								floatLabel="never"
								fxFlex
								mask="separator"
								thousandSeparator=","
								matInput
							/>
						</mat-form-field>
					</div>
				</div>
				<div fxFlex="25" fxLayoutAlign="start center">
					<div class="fw-700" fxFlex fxLayoutAlign="start center">Offer Rate:</div>
					<div fxFlex fxLayoutAlign="end center">
						<mat-form-field class="custom-form-field" fxFlexFill>
							<mat-icon class="primary-light-color vertical-align-bottom" matPrefix
								>attach_money
							</mat-icon>
							<input
								[(ngModel)]="projectCopy.offerRate"
								(ngModelChange)="projectCopy.offerRate = $event === '' ? null : $event"
								autocomplete="off"
								floatLabel="never"
								fxFlex
								mask="separator"
								thousandSeparator=","
								matInput
							/>
						</mat-form-field>
					</div>
				</div>
				<div fxFlex="25">
					<div class="fw-700" fxFlex fxLayoutAlign="start center">Best Rate:</div>
					<div fxFlex fxLayoutAlign="end center" class="lane-field">
						<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(projectCopy.bestRate)">
							{{ projectCopy.bestRate / 100 | currency: 'USD' : 'symbol' : '1.0-2' }}
						</span>
						<span
							*ngIf="IS_NULL_OR_UNDEFINED(projectCopy.bestRate)"
							fxLayoutAlign="center center"
						>
							<mat-icon
								[inline]="true"
								[matTooltip]="TOOLTIP_MSG.BEST_RATE"
								class="primary-text w-inherit"
								matTooltipClass="custom-tooltip"
							>
								info
							</mat-icon>
						</span>
					</div>
				</div>
				<!-- Automated Carrier Negotiation (CN-8626) — per-workflow override toggle, in the former
					 Stage slot. Stage is a Procurement-only field; moving the toggle here frees the Row-4 cell
					 so it no longer collides with "Assignee Is Dispatcher". Settings expand below when on.
					 Gated on the account entitlement. -->
				<div fxFlex="25" fxLayoutAlign="start center">
					<div *ngIf="baConfigService.AUTO_ACCEPT_ENTITLED" fxLayout="row" fxLayoutAlign="start center">
						<mat-checkbox
							[(ngModel)]="autoAcceptOverride"
							(change)="onAutoAcceptOverrideChange($event.checked)"
							[labelPosition]="'after'"
							color="primary"
							class="fn-size-13"
						>
							Override negotiation
						</mat-checkbox>
						<mat-icon class="primary-light-color ml-1" matTooltip="When off, this workflow inherits the account-level Automated Carrier Negotiation settings. When on, the values below apply only to this workflow." matTooltipClass="custom-tooltip">
							info
						</mat-icon>
					</div>
				</div>
			</div>
			<!-- Row 4: Book Now Up To Max Buy | Send to Network | Send Out of Network | Assignee Is Dispatcher -->
			<div class="font-size-14 p-0-3" fxLayout="row" fxLayoutGap="1.5rem">
				<div fxFlex="25">
					<div
						fxLayout="row"
						fxLayoutAlign="space-between center"
					>
						<span
							class="fw-700 cursor-pointer"
							(click)="projectCopy.bookNowUpToMaxBuy = !projectCopy.bookNowUpToMaxBuy"
							>Book Now Up To Max Buy:</span
						>
						<mat-checkbox
							[(ngModel)]="projectCopy.bookNowUpToMaxBuy"
							color="primary"
							class="fn-size-13"
						>
						</mat-checkbox>
					</div>
				</div>
				<div fxFlex="25" fxLayoutAlign="start center" class="fw-700">
					<mat-checkbox
						*ngIf="projectCopy.type == PROJECT_TYPES.WATERFALL.value"
						[(ngModel)]="projectCopy.inviteUngroupedCarriers"
						(ngModelChange)="sendOfferSettingUpdated($event, 'ungroupedCarriersDelay')"
						[labelPosition]="'before'"
						color="primary"
						class="fn-size-13"
					>
						Send to Network Carriers in
						<mat-form-field
							class="custom-form-field ungrouped-carriers-delay"
							fxFlex="12"
							appearance="standard"
						>
							<input
								[(ngModel)]="projectCopy.ungroupedCarriersDelay"
								autocomplete="off"
								floatLabel="never"
								fxFlex
								matInput
								[disabled]="!projectCopy.inviteUngroupedCarriers"
							/>
						</mat-form-field>
						min
					</mat-checkbox>
				</div>
				<div fxFlex="25" fxLayoutAlign="start center" class="fw-700 out-of-network-field">
					<mat-checkbox
						*ngIf="
							isWaterfallOrDedicatedLaneProject && accountSettings.ENABLE_OUT_OF_NETWORK_CARRIERS
						"
						[(ngModel)]="projectCopy.sendToOutOfNetworkCarriers"
						(ngModelChange)="sendOfferSettingUpdated($event, 'sendToOutOfNetworkCarriersDelay')"
						[labelPosition]="'before'"
						color="primary"
						class="fn-size-13"
					>
						Send Out of Network Offers in
						<mat-form-field
							class="custom-form-field ungrouped-carriers-delay"
							fxFlex="12"
							appearance="standard"
						>
							<input
								[(ngModel)]="projectCopy.sendToOutOfNetworkCarriersDelay"
								autocomplete="off"
								floatLabel="never"
								fxFlex
								matInput
								[disabled]="!projectCopy.sendToOutOfNetworkCarriers"
							/>
						</mat-form-field>
						min
					</mat-checkbox>
				</div>
				<div fxFlex="25" fxLayout="column" fxLayoutGap="0.5rem">
					<div
						fxLayout="row"
						fxLayoutAlign="space-between center"
						*ngIf="isMcleodIntegrationEnabled && isWaterfallOrDedicatedLaneProject"
					>
						<span
							class="fw-700 cursor-pointer"
							(click)="projectCopy.assigneeIsDispatcher = !projectCopy.assigneeIsDispatcher"
							>Assignee Is Dispatcher:</span
						>
						<mat-checkbox
							[(ngModel)]="projectCopy.assigneeIsDispatcher"
							color="primary"
							class="fn-size-13"
						>
						</mat-checkbox>
					</div>
				</div>
			</div>
			<!-- Automated Carrier Negotiation — per-workflow settings (the override toggle is in the row above); shown when override is on
				 AND the account is entitled (so a previously-saved override can't surface the settings on a de-entitled account). -->
			<div
				*ngIf="baConfigService.AUTO_ACCEPT_ENTITLED && autoAcceptOverride"
				class="font-size-14 p-0-3 auto-accept-settings-row auto-accept-row-compact"
				fxLayout="row"
				fxLayoutGap="1.5rem"
				fxLayoutAlign="start center"
			>
				<mat-checkbox
					fxFlex="25"
					class="fw-700"
					[(ngModel)]="projectCopy.autoAcceptEnabled"
					[labelPosition]="'before'"
					color="primary"
				>
					Enable automated negotiation
				</mat-checkbox>
				<div fxFlex="25" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem" class="auto-accept-margin-cell">
					<span class="m-r-1 auto-accept-margin-label-full fw-700" aria-hidden="true">Margin below ceiling</span>
					<span class="m-r-1 auto-accept-margin-label-short fw-700" aria-hidden="true">Margin</span>
					<mat-icon class="primary-light-color m-r-1" matTooltip="How far below the load ceiling an offer must land to auto-accept — percentage of the ceiling or a fixed dollar amount. Must be greater than 0." matTooltipClass="custom-tooltip">
						info
					</mat-icon>
					<mat-radio-group
						[(ngModel)]="projectCopy.autoAcceptMarginType"
						(change)="onAutoAcceptMarginTypeChange($event.value)"
					>
						<mat-radio-button color="primary" value="Percentage" aria-label="Percentage">%</mat-radio-button>
						&nbsp;
						<mat-radio-button color="primary" value="Dollar" aria-label="Fixed dollar amount">$</mat-radio-button>
					</mat-radio-group>
					<mat-form-field class="auto-accept-value-input auto-accept-field" subscriptSizing="dynamic">
						<span matPrefix class="m-r-1">{{ autoAcceptMarginPlaceholder }}</span>
						<input [(ngModel)]="autoAcceptMarginDisplay" matInput type="number" min="1" aria-label="Margin below ceiling" />
					</mat-form-field>
				</div>
				<div fxFlex="25" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
					<span class="m-r-1 fw-700">Urgency window (hours)</span>
					<mat-form-field class="auto-accept-value-input auto-accept-field" subscriptSizing="dynamic">
						<input [(ngModel)]="projectCopy.autoAcceptTimeXHours" matInput type="number" aria-label="Urgency window (hours)" />
					</mat-form-field>
				</div>
				<!-- Col 4: the auto-accept-&-book opt-in (a form of Book Now). Off ⇒ recommend the offer, don't book.
					 min-width:0 (auto-accept-book-cell) lets this fxFlex=25 cell shrink to its column so the fat
					 label doesn't overflow and break the four-column grid alignment. -->
				<div fxFlex="25" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem" class="auto-accept-book-cell">
					<mat-checkbox
						class="fw-700"
						[(ngModel)]="projectCopy.autoAcceptBookEnabled"
						[labelPosition]="'before'"
						color="primary"
					>
						Auto-book
					</mat-checkbox>
					<mat-icon class="primary-light-color" matTooltip="When on, an acceptable negotiated offer is auto-accepted and the load booked (a form of Book Now). When off, the Booking Assistant recommends you accept — it does not book." matTooltipClass="custom-tooltip">
						info
					</mat-icon>
				</div>
			</div>
			<!-- Row 5: Edit Notes | Appointment Required | Project Type | UPDATE -->
			<div class="font-size-14 p-0-3" fxLayout="row" fxLayoutGap="1.5rem" fxLayoutAlign="start center">
				<div fxFlex="25" fxLayoutAlign="start center">
					<div
						(click)="showNotes = !showNotes"
						class="cursor-pointer edit-notes-field"
						fxLayout="row"
						fxLayoutAlign="start center"
					>
						<span class="primary-text fw-700">Edit Notes</span>
						<span class="ml-1 lane-placeholder text-ellipsis">({{ getFirstNoteSummary() }})</span>
						<mat-icon *ngIf="!showNotes" class="vertical-align-middle primary-text">keyboard_arrow_down</mat-icon>
						<mat-icon *ngIf="showNotes" class="vertical-align-middle primary-text">keyboard_arrow_up</mat-icon>
					</div>
				</div>
				<div fxFlex="25" fxLayoutAlign="start center">
					<mat-checkbox
						class="fw-700"
						[(ngModel)]="projectCopy.appointmentRequired"
						[labelPosition]="'before'"
						color="primary"
					>
						Appointment Required
					</mat-checkbox>
					<mat-icon
						class="primary-light-color ml-1"
						matTooltip="When enabled, loads in this workflow will require appointment scheduling. This setting overrides the account-level Booking Assistant configuration."
						matTooltipClass="custom-tooltip"
					>
						info
					</mat-icon>
				</div>
				<!-- CN-8312: Project Type dropdown — same control / options as V1
				     workflow layout. Lets the user switch this Workflow project
				     back to Procurement (or between Waterfall / Dedicated Lane). -->
				<div fxFlex="25">
					<div class="fw-700" fxFlex fxLayoutAlign="start center">Project Type:</div>
					<div fxFlex fxLayoutAlign="start center">
						<mat-form-field class="custom-form-field" floatLabel="never" fxFlex>
							<mat-select [(ngModel)]="projectCopy.type" disableOptionCentering>
								<mat-option
									*ngFor="let option of workflowTypeOptions"
									[value]="option.value"
								>
									{{ option.label }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</div>
				<div fxFlex="25" fxLayoutAlign="end center">
					<button
						(click)="updateProject()"
						*ngIf="!isUpdatingProject"
						[disabled]="isUpdatingProject || !isProjectUpdated()"
						color="primary"
						fxFlex="100"
						mat-raised-button
					>
						UPDATE
					</button>
					<div
						*ngIf="isUpdatingProject"
						class="h-100"
						fxLayout="row"
						fxLayoutAlign="space-around center"
					>
						<mat-spinner [diameter]="30"></mat-spinner>
					</div>
				</div>
			</div>
		</ng-container>

		<!-- ========== SHARED NOTES SECTIONS (both Procurement and non-Procurement) ========== -->
		<div *ngIf="showNotes" class="font-size-14 p-0-3" fxLayout="row" fxLayoutGap="1.5rem">
			<div class="fw-700" fxFlex="21.5" fxLayoutAlign="start center">Packaging:</div>
			<div fxFlex fxLayoutAlign="start center">
				<app-special-instructions-dialog
					(updatedString)="projectCopy.packaging = $event; inputChanged('packaging')"
					[displaySecondaryButton]="true"
					[isEditable]="true"
					[layoutAlign]="'start center'"
					[specialInstructions]="projectCopy.packaging"
					fxFlex
					modalTitle="Packaging"
					primaryButtonText="Update"
				>
				</app-special-instructions-dialog>
			</div>
		</div>
		<div *ngIf="showNotes" class="font-size-14 p-0-3" fxLayout="row" fxLayoutGap="1.5rem">
			<div class="fw-700" fxFlex="21.5" fxLayoutAlign="start center">Trailer Requirements:</div>
			<div fxFlex fxLayoutAlign="start center">
				<app-special-instructions-dialog
					(updatedString)="
						projectCopy.trailerRequirements = $event; inputChanged('trailerRequirements')
					"
					[displaySecondaryButton]="true"
					[isEditable]="true"
					[layoutAlign]="'start center'"
					[specialInstructions]="projectCopy.trailerRequirements"
					fxFlex
					modalTitle="Trailer Requirements"
					primaryButtonText="Update"
				>
				</app-special-instructions-dialog>
			</div>
		</div>
		<div *ngIf="showNotes" class="font-size-14 p-0-3" fxLayout="row" fxLayoutGap="1.5rem">
			<div class="fw-700" fxFlex="21.5" fxLayoutAlign="start center">Shipper Notes:</div>
			<div fxFlex fxLayoutAlign="start center">
				<app-special-instructions-dialog
					(updatedString)="projectCopy.shipperNotes = $event; inputChanged('shipperNotes')"
					[displaySecondaryButton]="true"
					[isEditable]="true"
					[layoutAlign]="'start center'"
					[specialInstructions]="projectCopy.shipperNotes"
					fxFlex
					modalTitle="Shipper Notes"
					primaryButtonText="Update"
				>
				</app-special-instructions-dialog>
			</div>
		</div>
		<div *ngIf="showNotes" class="font-size-14 p-0-3" fxLayout="row" fxLayoutGap="1.5rem">
			<div class="fw-700" fxFlex="21.5" fxLayoutAlign="start center">Receiver Notes:</div>
			<div fxFlex fxLayoutAlign="start center">
				<app-special-instructions-dialog
					(updatedString)="projectCopy.receiverNotes = $event; inputChanged('receiverNotes')"
					[displaySecondaryButton]="true"
					[isEditable]="true"
					[layoutAlign]="'start center'"
					[specialInstructions]="projectCopy.receiverNotes"
					fxFlex
					modalTitle="Receiver Notes"
					primaryButtonText="Update"
				>
				</app-special-instructions-dialog>
			</div>
		</div>
	</mat-card-content>
</mat-card>
